import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const DataUploadBypassPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // replace, or Back from the destination re-runs this redirect forwards in a loop
    navigate('/settings/data-upload/import-data', { replace: true })
  }, [])
  return (
    <>
    </>
  )
}
